(function () {
  'use strict';

  /* ── Overlay positioning constants (bracelet) ── */
  var OVERLAY_CX = 0.49537037037037035;
  var OVERLAY_CY = 515 / 1080;
  var OVERLAY_D  = 350 / 1080;

  /* Both base images — overlay pre-rendered on EVERY base slide */
  var ALLOWED_BASES = ['/files/7.png', '/files/6.png'];

  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0827/9172/7443/files/';
  var selectedCounty = null;
  var selectedMaterial = 'gold';

  /* ── Helpers ── */

  function isBaseImage(src) {
    if (!src) return false;
    var clean = src.split('?')[0];
    for (var i = 0; i < ALLOWED_BASES.length; i++) {
      if (clean.indexOf(ALLOWED_BASES[i]) !== -1) return true;
    }
    return false;
  }

  function getOverlay(container) {
    var wrap = container.querySelector('.ceo-main');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'county-engraving-overlay ceo-main';
      var img = document.createElement('img');
      img.className = 'county-engraving-overlay__img';
      img.alt = '';
      img.draggable = false;
      img.decoding = 'sync';
      wrap.appendChild(img);
      container.appendChild(wrap);
    }
    return wrap;
  }

  function positionOverlay(overlay, imgEl, container) {
    if (!overlay || !imgEl) return;
    var imgRect = imgEl.getBoundingClientRect();
    var conRect = container.getBoundingClientRect();
    if (imgRect.width === 0 || imgRect.height === 0) return;

    var imgL = imgRect.left - conRect.left;
    var imgT = imgRect.top - conRect.top;
    var refSize = Math.min(imgRect.width, imgRect.height);
    var size = refSize * OVERLAY_D;
    var cx = imgL + imgRect.width * OVERLAY_CX;
    var cy = imgT + imgRect.height * OVERLAY_CY;

    overlay.style.width  = size + 'px';
    overlay.style.height = size + 'px';
    overlay.style.left   = (cx - size / 2) + 'px';
    overlay.style.top    = (cy - size / 2) + 'px';
  }

  function getProductImage(container) {
    return container.querySelector('.product__modal-opener img') ||
           container.querySelector('.product__media img');
  }

  function getEngravingUrl(key) {
    var urls = window.countyEngravingUrls || {};
    var url = urls[key];
    return (url && url.indexOf('/files/') !== -1) ? url : CDN_BASE + key + '.png';
  }

  /**
   * Collect every gallery slide container whose image is a base image.
   * Returns an array of { container, imgEl } objects.
   */
  function getAllBaseContainers() {
    var results = [];
    var viewers = document.querySelectorAll('[id^="GalleryViewer-"]');
    viewers.forEach(function (viewer) {
      var slides = viewer.querySelectorAll('.product__media-item');
      slides.forEach(function (slide) {
        var container = slide.querySelector('.product-media-container');
        if (!container) return;
        var imgEl = getProductImage(container);
        if (!imgEl) return;
        var src = imgEl.currentSrc || imgEl.src || '';
        if (isBaseImage(src)) {
          results.push({ container: container, imgEl: imgEl });
        }
      });
    });
    return results;
  }

  /* ── Core update — pre-renders overlay on ALL base slides at once ── */

  function updateAllOverlays() {
    /* Hide every existing overlay first */
    document.querySelectorAll('.county-engraving-overlay').forEach(function (el) {
      el.style.display = 'none';
    });

    if (!selectedCounty) return;

    var key = selectedCounty + '_' + selectedMaterial;
    var url = getEngravingUrl(key);
    if (!url) return;

    /* Pre-load the overlay image once, then stamp it onto every base slide */
    var bases = getAllBaseContainers();
    bases.forEach(function (b) {
      var overlay    = getOverlay(b.container);
      var overlayImg = overlay.querySelector('img');
      if (overlayImg.getAttribute('data-loaded') !== url) {
        overlayImg.setAttribute('data-loaded', url);
        overlayImg.src = url;
      }
      overlay.style.display = 'block';
      positionOverlay(overlay, b.imgEl, b.container);
    });
  }

  /* ── State readers ── */

  function readMaterial() {
    var fieldset = document.querySelector('fieldset[data-option-type="material"]');
    if (!fieldset) return 'gold';
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return (checked && checked.value.toLowerCase().indexOf('silver') !== -1) ? 'silver' : 'gold';
  }

  function readCounty() {
    var select = document.querySelector('[data-county-select]');
    if (select && select.value) return select.value;
    var radio = document.querySelector('fieldset[data-option-type="county"] input[type="radio"]:checked');
    return radio ? radio.value : null;
  }

  /* ── Event binding ── */

  function bindEvents() {
    /* County select / radio */
    document.querySelectorAll('[data-county-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        selectedCounty = this.value || null;
        updateAllOverlays();
      });
    });

    document.querySelectorAll('fieldset[data-option-type="county"] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) {
          selectedCounty = this.value;
          updateAllOverlays();
        }
      });
    });

    /* Material radio */
    document.querySelectorAll('fieldset[data-option-type="material"] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var m = readMaterial();
        if (m !== selectedMaterial) {
          selectedMaterial = m;
          setTimeout(updateAllOverlays, 120);
        }
      });
    });

    /* Resize — reposition all overlays */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (selectedCounty) updateAllOverlays();
      }, 150);
    });

    /* Image load — an image may have loaded lazily, re-check bases */
    document.querySelectorAll('[id^="GalleryViewer-"] img').forEach(function (img) {
      img.addEventListener('load', function () {
        if (selectedCounty) updateAllOverlays();
      });
    });

    /* Slide class changes — variant switch may swap gallery images */
    document.querySelectorAll('[id^="Slider-Gallery-"]').forEach(function (slider) {
      var observer = new MutationObserver(function () {
        if (selectedCounty) setTimeout(updateAllOverlays, 60);
      });
      observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });

    /* Image src/srcset changes — variant switch may change image srcs */
    document.querySelectorAll('[id^="GalleryViewer-"] .product__media-item img').forEach(function (img) {
      var srcObserver = new MutationObserver(function () {
        if (selectedCounty) setTimeout(updateAllOverlays, 100);
      });
      srcObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
    });
  }

  /* ── Init ── */

  function init() {
    selectedMaterial = readMaterial();
    selectedCounty  = readCounty();
    bindEvents();
    updateAllOverlays();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();